import React, { useEffect, useState } from 'react'
import logoSvg from '../../assets/images/sensei-new-logo.svg'
import logoSvg2 from '../../assets/images/sensei-new-logo-2.0.svg'
import { useDispatch, useSelector } from 'react-redux'
import { ShowMeasure, UsertourAction, handleMobileDraw, handlePriceAndSummaryMobileView, handleProfileModal, handleShowBookDemo } from '../../action';
import ZipcodeTooltip from './ZipcodeTooltip';
import AfterLogedIn from '../Login/AfterLogedIn';
import BookADemoTooltip from '../ControlPanel/Common/BookADemoTooltip';
import { downloadOnClick, prepareTwoDMapData } from '../../action/2d_mapping/twoDMap.action';
import { handleCommonModal, handleProductModal } from '../../action/quote_order/leadcustomer.action';
import { CheckCaptureModalImage } from '../../action/extra_options/orderExtras.action';
import { addLeadDetails, handleSaveLatter, handleSavePublicQuote } from '../../action/quote_order/quote.action';
import { manufacturerLogo } from '../../redux/reducers/utils';

const MobileHeader = () => {
    const state = useSelector((state) => state.reducer)
    const dispatch = useDispatch();
    const [isShowZipTooltip, setShowZipTooltip] = useState(false);
    const [isActiveLogin, setIsActiveLogin] = useState(false);
    const [logoUrl, setLogoUrl] = useState(null);

    useEffect(() => {
        manufacturerLogo().then((url) => {
        if (url) setLogoUrl(url);
        });
    }, []);

    useEffect(() => {
        if (localStorage.getItem('userData')!=undefined) {
            setIsActiveLogin(true)
        }
        else {
            setIsActiveLogin(false)
        }
    }, [])

    const showPriceSummary = () => {
        dispatch(handlePriceAndSummaryMobileView(1));
        const removea = document.querySelector("body");
        removea.classList.add("active-total-price");
    }

    const onSaveClick = async () => {
        await dispatch(downloadOnClick(false));
        await dispatch(prepareTwoDMapData());
        //autoGeneratedPDF();
        if (state.const_var.callMesure) {
            dispatch(ShowMeasure("save"));
        }
    };

    const saveShareClick = () => {
        const {loginSession, crmSetting, isPublicEdit, i_g_A_y } = state.const_var;
        if(crmSetting.is_module_name == 'inventory'){
            dispatch(handleProductModal());
        }else{
            if(isPublicEdit != true){
                if(crmSetting.form_action == "edit" && i_g_A_y.length > 0){
                    dispatch(CheckCaptureModalImage('open'));
                }else{
                    if(loginSession == false){
                        dispatch(handleSaveLatter('open'));
                    }else{
                        dispatch(handleCommonModal('lead_customer', 'save'));
                    }
                }
            }else{
                dispatch(handleSavePublicQuote('open'));
            }
            onSaveClick();
        }
    }

    let dynamicLogo = logoUrl;
    let logoIMG = window.location.origin + '/logo.svg';
    if(state.const_var.loginSession == true && dynamicLogo /* state.const_var.crmSetting.api_token=="7KJeHld8lthhZRr0qzJEjYfnbjmXhXiKSGa73bv1XqENGNIthoKdbT4gIznBTV7i" */)
    {
            logoIMG = dynamicLogo;
    }else{
            logoIMG = window.location.origin + '/logo.svg';
    }
    let orderNowInitialCheck = state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false && state.const_var.stateData && state.const_var.stateData.hide_price_calculation == 0 &&  (state.const_var.crmSetting.is_show_cta == true || state.const_var.crmSetting.is_show_cta == undefined);
    
    let orderNowOtherCheck = state.const_var.crmSetting.is_module_name === "inventory" || (state.const_var.isPublicEdit==true && state.const_var.crmSetting.is_quote_Edit==true || state.const_var.isPublicEdit==true)
    
    return (
        <div className='mobile-header'>
            <div className={'logo-container' + (state.const_var.crmSetting.main_domain_url == "americansteelinc.com" ? ' logo-container-inc' : '')} onClick={() => dispatch(handleMobileDraw(false))}>
                {
                    state.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' 
                    ?
                    (
                        state.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com' && state.const_var.loginSession === false
                        ? 
                            <div className='metal-depotllc-btns'>
                                <button
                                    // onClick={() => {dispatch(addLeadDetails())}}
                                    onClick={(e) => {
                                                    dispatch(handleSaveLatter('open'));
                                                    onSaveClick();
                                            }}
                                    className={state.const_var.is_loader == false ? "btn btn-primary mr-2" : "btn btn-primary disabled mr-2"}
                                >
                                    <span className="icon mr-1"><i className="icon-quote-icon"></i></span>
                                    <span className="text"> GET FORMAL QUOTE</span>
                                </button>
                            </div>
                        :
                            null
                    )
                    :
                    (
                    ((state.const_var.crmSetting.main_domain_url == '' && !dynamicLogo) || (state.const_var.crmSetting.main_domain_url == 'vaibhavcibirix.com')) ?
                    <img src={window.location.origin + '/logo.svg'} alt='logo img' className='w110' />
                    // <img src={logoSvg2} alt='logo img' className='w110' />
                    :
                    <img src={logoIMG} alt='logo img'/>
                    // <img src={logoSvg} alt='logo img'/>
                    )
                }
            </div>
            <div className='action-container'>


                {state.const_var.crmSetting.main_domain_url == 'metalcarportdepotllc.com'
                    ?
                        <div className='action-item'>
                            {(state.const_var.crmSetting.is_module_name == "inventory") ?
                                <div style={{lineHeight: 1}}>
                                    <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                        id="save_update_inventory_automation"
                                        onClick={(e) => dispatch(handleProductModal())}
                                    >
                                        {state.const_var.crmSetting.main_domain_url == 'idealsteelbuildingsofca.com' ?
                                            <span className='btn btn-primary mobile-btn-primary'>
                                                <span className="text sales-login-text">
                                                    {(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}
                                                </span>
                                                {/* <span className="icon">
                                                    <i className="icon-double-arrow-ico"></i>
                                                </span> */}
                                            </span> 
                                            :
                                            <span className="icon icon-save icon-save-depot"></span>
                                        }
                                    </a>
                                </div>
                                :
                                <>
                                {(state.const_var.isPublicEdit != true) ?
                                    <div style={{lineHeight: 1}}>
                                        <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                            id="save_update_orderquote_automation"
                                            onClick={(state.const_var.crmSetting.form_action == "edit" &&
                                                state.const_var.i_g_A_y.length > 0)
                                                ?
                                                (e) => {
                                                dispatch(CheckCaptureModalImage('open'))
                                                onSaveClick();
                                                }
                                                :
                                                (state.const_var.loginSession == false)
                                                ?
                                                (e) => {
                                                    dispatch(handleSaveLatter('open'));
                                                    onSaveClick();
                                                }
                                                :
                                                (e) => {
                                                    dispatch(handleCommonModal('lead_customer', 'save'))
                                                    onSaveClick();
                                                }
                                            }
                                        >
                                            {orderNowInitialCheck ? (
                                                state.const_var.loginSession === false ? (
                                                    orderNowOtherCheck ? null : (
                                                        <span className={`icon icon-save icon-save-depot ${(state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com") ? ' highlighted' : ''}`}></span>
                                                    )
                                                ) : null
                                            ) : ( 
                                                state.const_var.crmSetting.main_domain_url == 'idealsteelbuildingsofca.com' ?
                                                    <span className='btn btn-primary mobile-btn-primary'>
                                                        <span className={`${state.const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && 'ideal-steel-no-caps'} text`}>
                                                            {
                                                                state.const_var.crmSetting.form_action == "edit"
                                                                    ?
                                                                    (state.const_var.crmSetting.is_module_name == "quote")
                                                                    ?
                                                                    "Update Quote"
                                                                    :
                                                                    "Update & Share"
                                                                    :
                                                                    (state.const_var.crmSetting.is_module_name == "quote")
                                                                ?
                                                                    state.const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(state.const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!" : "Save & Share")
                                                                :
                                                                    state.const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" ? "Get Quote & SAVE" :(state.const_var.crmSetting.main_domain_url == "discoverybuildings.com" ? "Click Here For Lowest Price!": "Save & Share")
                                                            }
                                                        </span>
                                                        {/* <span className="icon">
                                                            <i className="icon-double-arrow-ico"></i>
                                                        </span> */}
                                                    </span>
                                                    :
                                                    <span className='btn btn-primary mobile-btn-primary'>
                                                        <span className='text'>{(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : state.const_var.crmSetting.main_domain_url == "solidrockstructuresllc.com" ? "Current sales" : "Save")}</span>
                                                        {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                                    </span>
                                                )
                                            }
                                        </a>
                                    </div>
                                    :
                                    <div style={{lineHeight: 1}}>
                                        <a className={state.const_var.crmSetting.order_now == true && state.const_var.checkmoreCustomizeFlag == false ? "before-login flex-column header-btn-with-text" : 'before-login flex-column header-btn-with-text main-action-btn'}
                                        id="save_update_orderquote_automation"
                                        onClick={(e) => { dispatch(handleSavePublicQuote('open')); onSaveClick(); }}
                                        >
                                            {state.const_var.crmSetting.main_domain_url == 'idealsteelbuildingsofca.com' ?
                                                <span className='btn btn-primary mobile-btn-primary'>
                                                    <span className='text'>Update & Share</span>
                                                    {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                                </span>
                                                :
                                                <span className='btn btn-primary mobile-btn-primary'>
                                                    <span className='text'>{(state.const_var.crmSetting.form_action == "edit") ? "Update" : (state.const_var.crmSetting.main_domain_url == "prometalbuildings.com" || state.const_var.crmSetting.main_domain_url == "trinitysteelstructures.com" ? "Save & Share" : "Save")}</span>
                                                    {/* <span className='icon'><i className='icon-double-arrow-ico'></i></span> */}
                                                </span>
                                            }
                                        </a>
                                    </div>
                                }
                                </>
                            }
                        </div>
                    :
                        null
                }

                <div data-tut="headpaneldevice">
                    {
                        !(state.const_var.loginSession || isActiveLogin) &&
                        <div className='action-item relative call-tooltip'>
                            <i className='icon-phone-ico' onClick={() => dispatch(handleShowBookDemo())}></i>
                            {
                                state.const_var.crmSetting.source!="https://estimator.warriorbuildings.com/" && state.isShowBookDemo && !state.const_var.loginSession &&
                                <BookADemoTooltip />
                            }
                        </div>
                    }
                </div>
                <div className='action-item' onClick={() => setShowZipTooltip(true)}>
                    <i className='icon-map-ico'></i>
                    {
                        isShowZipTooltip && <div className='zip-code-overlay'></div>
                    }
                    <ZipcodeTooltip isShowZipTooltip={isShowZipTooltip} setShowTooltip={(value) => setShowZipTooltip(value)} />
                </div>
                <div className='action-item' data-tut="headpaneldevice" onClick={showPriceSummary}>
                    <i className='icon-summary-ico'></i>
                </div>
                <div className={state.const_var.crmSetting.main_domain_url == "Walkerbuildings.com" ? 'action-item' : 'action-item d-none'} onClick={() => saveShareClick()}>
                    <i className='icon-save-icon'></i>
                </div>
                {
                    state.const_var.loginSession &&
                    <div className='action-item' onClick={() => dispatch(handleProfileModal(true))}>
                        <i className='icon-hamburger-ico'></i>
                        { state.const_var.loginSession || isActiveLogin ? <AfterLogedIn /> : ''}
                    </div>
                }
                <div className='action-item' 
                    onClick={()=> {
                        dispatch(handleMobileDraw(false))
                        dispatch(UsertourAction(true, '', 0))
                    }}
                >
                    <span className="icon-tour-1 tour-icon-style"></span>
                </div>
            </div>
        </div> 
    )
}

export default MobileHeader